<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    tokenSeparators?: string[]
  }>(),
  {
    tokenSeparators: () => [' ', ',', '，'],
  },
)

const modelValue = defineModel<string[]>('value', { required: false })

const searchValue = ref('')

watch(
  searchValue,
  (val) => {
    if (val && [...val].some((char) => props.tokenSeparators.includes(char))) {
      const values = val
        .split(new RegExp(props.tokenSeparators.join('|')))
        .filter(Boolean)
      const set = new Set([...(modelValue.value ?? []), ...values])
      modelValue.value = [...set]
      nextTick(() => {
        searchValue.value = ''
      })
    }
  },
  { immediate: true },
)

function handleSearch(val: string) {
  searchValue.value = val
}

function handleChange() {
  nextTick(() => {
    searchValue.value = ''
  })
}
</script>

<template>
  <ASelect
    placeholder="输入"
    allow-clear
    mode="tags"
    :max-tag-count="1"
    :max-tag-text-length="4"
    not-found-content="通过空格、逗号、回车分隔"
    :search-value="searchValue"
    @search="handleSearch"
    @change="handleChange"
    v-model:value="modelValue"
  />
</template>
